import { useState, useEffect } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';

const categories = [
  { name: 'Shoes', href: 'https://kaspreadsheet.com/category-911-Shoes.html', icon: 'ri-footprint-line' },
  { name: 'Hoodies / Sweaters', href: 'https://kaspreadsheet.com/search-912/name/Shoes.html', icon: 'ri-t-shirt-line' },
  { name: 'T-Shirts', href: 'https://kaspreadsheet.com/search-913/name/Shoes.html', icon: 'ri-shirt-line' },
  { name: 'Jackets', href: 'https://kaspreadsheet.com/search-914/name/Shoes.html', icon: 'ri-honour-line' },
  { name: 'Pants / Shorts', href: 'https://kaspreadsheet.com/search-915/name/Shoes.html', icon: 'ri-tools-line' },
  { name: 'Headwear', href: 'https://kaspreadsheet.com/search-916/name/Shoes.html', icon: 'ri-user-smile-line' },
  { name: 'Sets', href: 'https://kaspreadsheet.com/search-917/name/Shoes.html', icon: 'ri-stack-line' },
  { name: 'Underwear', href: 'https://kaspreadsheet.com/search-918/name/Shoes.html', icon: 'ri-checkbox-blank-circle-line' },
  { name: 'Jersey', href: 'https://kaspreadsheet.com/search-919/name/Shoes.html', icon: 'ri-football-line' },
  { name: 'Accessories', href: 'https://kaspreadsheet.com/search-920/name/Shoes.html', icon: 'ri-star-line' },
  { name: 'Bags', href: 'https://kaspreadsheet.com/search-921/name/Shoes.html', icon: 'ri-shopping-bag-3-line' },
  { name: 'Belts', href: 'https://kaspreadsheet.com/search-922/name/Shoes.html', icon: 'ri-link' },
  { name: 'Perfumes', href: 'https://kaspreadsheet.com/search-923/name/Shoes.html', icon: 'ri-drop-line' },
  { name: 'Other Stuff', href: 'https://kaspreadsheet.com/search-924/name/Shoes.html', icon: 'ri-more-line' },
];

const articleLinks = [
  { to: '/', label: 'Home', icon: 'ri-home-line' },
  { to: '/superbuy-spreadsheet-complete-guide', label: 'Complete Guide', icon: 'ri-book-read-line' },
  { to: '/superbuy-spreadsheet-shoes-guide', label: 'Shoes Guide', icon: 'ri-footprint-line' },
  { to: '/superbuy-spreadsheet-vs-alternatives', label: 'vs Alternatives', icon: 'ri-scales-3-line' },
  { to: '/superbuy-spreadsheet-beginner-tutorial', label: 'Beginner Tutorial', icon: 'ri-user-smile-line' },
  { to: '/superbuy-spreadsheet-tips-tricks', label: 'Tips & Tricks', icon: 'ri-lightbulb-line' },
  { to: '/superbuy-spreadsheet-safety-guide', label: 'Safety Guide', icon: 'ri-shield-check-line' },
  { to: '/superbuy-spreadsheet-product-discovery', label: 'Product Discovery', icon: 'ri-search-eye-line' },
  { to: '/superbuy-spreadsheet-review-2026', label: 'Review 2026', icon: 'ri-star-line' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : isHome
            ? 'bg-transparent'
            : 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <RouterLink to="/" className="flex items-center gap-2 group">
            <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-grid-fill text-background-50 text-lg"></i>
            </div>
            <span className={`font-heading text-lg font-semibold whitespace-nowrap transition-colors ${
              scrolled || !isHome ? 'text-foreground-900' : 'text-white'
            }`}>
              Superbuy Spreadsheet
            </span>
          </RouterLink>

          <div className="hidden md:flex items-center gap-1">
            <RouterLink
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-all duration-200 ${
                location.pathname === '/'
                  ? 'bg-primary-100 text-primary-700'
                  : scrolled || !isHome
                    ? 'text-foreground-700 hover:text-foreground-950 hover:bg-background-200'
                    : 'text-white/90 hover:text-white hover:bg-white/10'
              }`}
            >
              Home
            </RouterLink>
            <RouterLink
              to="/superbuy-spreadsheet-complete-guide"
              className={`px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-all duration-200 ${
                location.pathname === '/superbuy-spreadsheet-complete-guide'
                  ? 'bg-primary-100 text-primary-700'
                  : scrolled || !isHome
                    ? 'text-foreground-700 hover:text-foreground-950 hover:bg-background-200'
                    : 'text-white/90 hover:text-white hover:bg-white/10'
              }`}
            >
              Guides
            </RouterLink>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="ml-3 px-5 py-2.5 rounded-lg bg-primary-500 text-white text-sm font-semibold whitespace-nowrap hover:bg-primary-600 transition-all duration-200"
            >
              Buy It Now
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
              scrolled || !isHome ? 'text-foreground-700 hover:bg-background-200' : 'text-white hover:bg-white/10'
            }`}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 max-h-[80vh] overflow-y-auto">
          <div className="px-4 py-4 flex flex-col gap-1">

            <div className="mb-3">
              <span className="block px-3 py-1.5 text-xs font-semibold text-foreground-400 uppercase tracking-wider">Navigation</span>
              <RouterLink
                to="/"
                onClick={() => setMobileOpen(false)}
                className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                  location.pathname === '/' ? 'bg-primary-100 text-primary-700' : 'text-foreground-700 hover:bg-background-200'
                }`}
              >
                <i className="ri-home-line w-5 h-5 flex items-center justify-center"></i>
                Home
              </RouterLink>
            </div>

            <div className="mb-3">
              <span className="block px-3 py-1.5 text-xs font-semibold text-foreground-400 uppercase tracking-wider">In-Depth Guides</span>
              {articleLinks.slice(1).map((link) => (
                <RouterLink
                  key={link.to}
                  to={link.to}
                  onClick={() => setMobileOpen(false)}
                  className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                    location.pathname === link.to ? 'bg-primary-100 text-primary-700' : 'text-foreground-700 hover:bg-background-200'
                  }`}
                >
                  <i className={`${link.icon} w-5 h-5 flex items-center justify-center`}></i>
                  {link.label}
                </RouterLink>
              ))}
            </div>

            <div className="mb-3">
              <span className="block px-3 py-1.5 text-xs font-semibold text-foreground-400 uppercase tracking-wider">Shop Categories</span>
              {categories.map((cat) => (
                <a
                  key={cat.name}
                  href={cat.href}
                  target="_blank"
                  rel="noopener nofollow"
                  onClick={() => setMobileOpen(false)}
                  className="flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-200 transition-colors"
                >
                  <i className={`${cat.icon} w-5 h-5 flex items-center justify-center text-primary-500`}></i>
                  {cat.name}
                  <i className="ri-external-link-line text-foreground-400 text-xs ml-auto"></i>
                </a>
              ))}
            </div>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              onClick={() => setMobileOpen(false)}
              className="mt-2 px-4 py-3.5 rounded-lg bg-primary-500 text-white text-sm font-semibold text-center hover:bg-primary-600 transition-all duration-200"
            >
              Buy It Now
              <i className="ri-arrow-right-up-line ml-1.5"></i>
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}